import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-safety-induction-setup',
  templateUrl: './safety-induction-setup.component.html',
  styleUrls: ['./safety-induction-setup.component.css']
})
export class SafetyInductionSetupComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
